import styled from 'styled-components'

export const ActionDiv = styled.div`
    width: 14.5vw;
    border: 1px 1px 0px 1px solid #EBEBEB;
    padding: 12px;
    cursor: pointer;
    
    &:hover {
        background-color: #E6F4FB;
    }
`

export const ActionText = styled.p`
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #303030;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        color: #0090D3;
    }
`

export const ActionLink = styled.a`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: inherit;

  &:hover {
    color: #0090D3;
  }

  img {
    width: 18px;
    height: 18px;
  }
`